import './Button.css';
import { Link } from 'react-router-dom';
import { ButtonHTMLAttributes, ReactNode } from 'react';
import { Icon, play } from '../../components/Icon/Icon';

export const Button = ({
	className = '',
	disabled,
	...props
}: ButtonHTMLAttributes<HTMLButtonElement>): JSX.Element => {
	return <button className={`button ${className} ${disabled ? 'disabled' : ''}`} disabled={disabled} {...props} />;
};

type ButtonLinkProps = {
	linkTo: string;
	className?: string;
	target?: string;
	disabled?: boolean;
	children: ReactNode | string;
	onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};
export const ButtonLink = ({
	linkTo,
	className = '',
	target,
	disabled,
	onClick,
	children,
}: ButtonLinkProps): JSX.Element => {
	return (
		<Link
			to={linkTo}
			onClick={(e) => {
				if (disabled) e.preventDefault();
				else if (onClick) onClick(e);
			}}
			target={target}
			className={`button ${className} ${disabled ? 'disabled' : ''}`}
		>
			{children}
		</Link>
	);
};

type ExternalLinkProps = {
	href: string;
	className?: string;
	children: ReactNode;
};
export const ExternalLink = ({ href, children }: ExternalLinkProps): JSX.Element => {
	return (
		<>
			<Icon shape={play} size={19} />{' '}
			<span>
				<a href={href} target="_blank" rel="noreferrer" className="product-external-link">
					{children}
				</a>
			</span>
		</>
	);
};
